import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";

import HeaderNew from "../containers/Renewal/HeaderNew";
import PickCustomer from "../containers/QuoteBuilder/PickCustomer";
import Customer from "../containers/QuoteBuilder/Customer";
import Quotes from "../containers/QuoteBuilder/Quotes";

const AppQuoteBuilder = (props) => {
	const { customerName, makeModels, municipalities, trackData, customerEmail } =
		props;

	return (
		<>
			<HeaderNew customerName={customerName} />
			<Switch>
				<Route exact path={`/admin/quote-builder`}>
					<PickCustomer customerEmail={customerEmail} />
				</Route>
				<Route exact path={`/admin/quote-builder/build`}>
					<Customer
						makeModels={makeModels}
						municipalities={municipalities}
						trackData={trackData}
					/>
				</Route>
				<Route exact path={`/admin/quote-builder/list-quotes`}>
					<Quotes makeModels={makeModels} />
				</Route>
			</Switch>
		</>
	);
};

export default AppQuoteBuilder;
